/**
 * PosHardwareTestsSection — Pruebas de hardware del panel POS: imprimir página
 * de prueba y abrir gaveta (de un solo uso, anti-fraude).
 *
 * QUÉ EXPORTA: PosHardwareTestsSection (named).
 */

import { Loader2, Lock, Printer, ShieldAlert } from "lucide-react";

interface PosHardwareTestsSectionProps {
  testBusy: boolean;
  onTestPrint: () => void;
  drawerTestEnabled: boolean;
  drawerTestUsed: boolean;
  onTestDrawer: () => void;
  isWeb: boolean;
  webTestReady: boolean;
  printerConfigured: boolean;
  transportNone: boolean;
}

export function PosHardwareTestsSection({
  testBusy,
  onTestPrint,
  drawerTestEnabled,
  drawerTestUsed,
  onTestDrawer,
  isWeb,
  webTestReady,
  printerConfigured,
  transportNone,
}: PosHardwareTestsSectionProps) {
  return (
    <div className="space-y-2 pt-1">
      <button
        type="button"
        onClick={onTestPrint}
        disabled={
          !webTestReady || testBusy || transportNone || !printerConfigured
        }
        className="w-full flex items-center justify-center gap-2 py-3 rounded-xl border-2 border-primary-600 text-primary-700 dark:text-primary-300 font-black text-xs uppercase tracking-wide disabled:opacity-40"
      >
        {testBusy ? (
          <Loader2 size={16} className="animate-spin" />
        ) : (
          <Printer size={16} />
        )}
        {isWeb && !webTestReady
          ? "Configura la impresora para probar"
          : "Imprimir prueba"}
      </button>

      <button
        type="button"
        onClick={onTestDrawer}
        disabled={isWeb || !drawerTestEnabled}
        className={`w-full flex items-center justify-center gap-2 py-2.5 rounded-xl border text-xs font-bold transition-all
        ${
          drawerTestEnabled
            ? "border-gray-200 dark:border-slate-600 text-gray-700 dark:text-slate-200 hover:bg-gray-50 dark:hover:bg-slate-800"
            : "border-gray-100 dark:border-slate-700 text-gray-400 dark:text-slate-500 bg-gray-50 dark:bg-slate-800/50 cursor-not-allowed"
        }`}
      >
        {drawerTestUsed ? <Lock size={14} /> : null}
        {drawerTestUsed ? "Prueba de gaveta usada" : "Probar gaveta"}
      </button>
      {drawerTestUsed ? (
        <div className="flex items-start gap-2 px-1 text-[10px] text-amber-600 dark:text-amber-400 leading-snug">
          <ShieldAlert size={12} className="shrink-0 mt-px" />
          <span>
            Por seguridad sólo se permite <strong>1 prueba</strong> de gaveta.
            Para volver a probar, elimina la configuración con la papelera de
            abajo y configúrala de nuevo.
          </span>
        </div>
      ) : printerConfigured ? (
        <p className="px-1 text-[10px] text-gray-500 dark:text-slate-400 leading-snug">
          Esta prueba es de un solo uso. Después quedará bloqueada para que
          ningún empleado pueda abrir la caja desde Ajustes.
        </p>
      ) : null}
    </div>
  );
}
